<style lang="less" scoped>
@import '../../../style/common/variable';
.first {position: relative;width: 1200px;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0px auto;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 40px;}
.chxxb {display: flex;flex-direction: column;
p {line-height: 50px;font-size: 20px;font-weight: 600;letter-spacing: 3px;display: flex;flex-direction: column;
i {width: 50px;height: 3px;display: inline-block;background: #3c77bb;margin: auto;}}}
.formBox{width: 1180px;margin-left: -10px;margin-top: 20px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border: 1px solid #e2e1e1;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.td_left {width: 200px;text-indent: 10px;background-color: #fcfcfc;}
.td_center{width: 200px;background-color: #fcfcfc;}
.td_right {background-color: #fcfcfc;padding-left: 10px;}
.td_right span{font-size: 16px;}
.el-input {width: 400px;}
.el-select {width: 400px;}
.el-form-item {margin-bottom: 0;float: left;}
.el-button{margin-top: 20px;}
/deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}

@media screen and (max-width: @max-screen){
  .first {width: 100%;margin-bottom: 20px;transform: scale(0.9);transform-origin: top center;}
  .chxxb p {font-size: 16px;line-height: 30px;letter-spacing: 1.2px;}
  .formBox {width: 100%;margin-left: -20px;transform: scale(0.95);}
  .td_left,
  .td_center { width: 28%; min-width: 80px;}
  .el-input,.el-select {width: 320px !important;}
  .el-form-item {margin-bottom: 10px !important;}
  .td_right span {font-size: 14px;}
  table {zoom: 0.85;width: 100%;}
  tr, td { padding: 3px; border-width: 0.8px;}
  .el-button { margin-top: 15px; padding: 8px 16px; font-size: 14px;}
  /deep/.el-form-item__error {font-size: 14px; line-height: 32px;}
}
</style>

<template>
  <div class="first">
    <div class="chxxb" id="hyrc">
      <p><span>办会报名表</span><i></i></p>
      <el-form ref="form" :model="form" :rules="rules" class="formBox">
        <table>
          <tr class="tr">
            <td class="td_left" rowspan="5">基本信息</td>
            <td class="td_center">
              <span v-if="isMandatory('hyname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>会议名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.hyname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('hyzt')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>会议主题
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.hyzt" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('nhsj')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>拟办会时间
            </td>
            <td class="td_right">
              <el-form-item>
                <el-date-picker v-model="form.nhsj" value-format="timestamp" type="datetime" placeholder="请选择办会时间"></el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('nhaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>拟办会地点
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.nhaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('nhgm')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>拟办会规模
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.nhgm" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left" rowspan="6">主办方</td>
            <td class="td_center">
              <span v-if="isMandatory('gsname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('gsaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gsaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('gstype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.gstype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('lxrname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.lxrname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('tel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系电话
            </td>
            <td class="td_right">
              <el-form-item prop="tel">
                <el-input v-model="form.tel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mall')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.mall" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left" rowspan="6">协办方</td>
            <td class="td_center">
              <span v-if="isMandatory('xbname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbgsaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbgsaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbgstype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xbgstype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xblxr')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.xblxr" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbtel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系电话
            </td>
            <td class="td_right">
              <el-form-item prop="tel">
                <el-input v-model="form.xbtel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('xbmall')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.xbmall" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left" rowspan="6">媒体</td>
            <td class="td_center">
              <span v-if="isMandatory('mtname')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司名称
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mtname" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mtaad')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司地址
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mtaad" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mttype')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>公司性质
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mttype" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mtlxr')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系人
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.mtlxr" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mttel')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>联系电话
            </td>
            <td class="td_right">
              <el-form-item prop="tel">
                <el-input v-model="form.mttel" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_center">
              <span v-if="isMandatory('mtmall')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>邮箱
            </td>
            <td class="td_right">
              <el-form-item prop="email">
                <el-input v-model="form.mtmall" class="input"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr">
            <td class="td_left">其它</td>
            <td class="td_center">
              <span v-if="isMandatory('opacity')" class="f_red">*</span>
              <span v-else class="f_hid">*</span>留言
            </td>
            <td class="td_right">
              <el-form-item>
                <el-input v-model="form.opacity" class="input" style="width:740px;"></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <el-button type="primary" @click="submit">提交</el-button>
  </div>
</template>

<script>
/**
 * 何宽
 * 办会报名页
 */
export default {
  data()
  {
    // 手机验证规则
    let InputTel = (rule, value, callback) =>
    {
      let regtel = /^1[3|4|5|7|8][0-9]{9}$/
      if (!value)
        return callback(new Error('电话不能为空'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的联系电话'))
        else
          callback()
      }
    }
    return {
      form: {
        hyname: '',
        hyzt: '',
        nhsj: null,
        nhaad: '',
        nhgm: '',
        gsname: '',
        gsaad: '',
        gstype: '',
        lxrname: '',
        tel: '',
        mall: '',
        xbname: '',
        xbgsaad: '',
        xbgstype: '',
        xblxr: '',
        xbtel: '',
        xbmall: '',
        mtname: '',
        mtaad: '',
        mttype: '',
        mtlxr: '',
        mttel: '',
        mtmall: '',
        opacity: ''
      },
      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        tel: [{ validator: InputTel, trigger: 'blur' }]
      },
      //表名
      tabname: 'dmcn_bhxxb',
      //fld表数据
      fldData: []
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
  },
  methods: {
    // 报名
    submit()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 61,
        retAtt: 1,
        hyname: this.form.hyname,
        hyzt: this.form.hyzt,
        nhsj: this.form.nhsj / 1000,
        nhaad: this.form.nhaad,
        nhgm: this.form.nhgm,
        gsname: this.form.gsname,
        gsaad: this.form.gsaad,
        gstype: this.form.gstype,
        lxrname: this.form.lxrname,
        tel: this.form.tel,
        mall: this.form.mall,
        xbname: this.form.xbname,
        xbgsaad: this.form.xbgsaad,
        xbgstype: this.form.xbgstype,
        xblxr: this.form.xblxr,
        xbtel: this.form.xbtel,
        xbmall: this.form.xbmall,
        mtname: this.form.mtname,
        mtaad: this.form.mtaad,
        mttype: this.form.mttype,
        mtlxr: this.form.mtlxr,
        mttel: this.form.mttel,
        mtmall: this.form.mtmall,
        opacity: this.form.opacity
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '报名失败，请检查是否有未填写的内容或者填写不规范或者不符合填写规范', type: 'error', customClass: 'mzindex'})
        else
          this.$message({message: '报名成功', type: 'success', customClass: 'mzindex'})
      })
      for (let key in this.form)
        this.form[key] = null
    },
    // 返回
    backtrack()
    {
      this.$router.go(-1)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/Bhxxb.vue